export default __webpack_public_path__ + "static/media/15.0115c63a.gif";